"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _couponCodeList = _interopRequireDefault(require("./couponCodeList.vue"));
var _couponCodeAdd = _interopRequireDefault(require("./couponCodeAdd.vue"));
var _redeemList = _interopRequireDefault(require("./redeemList.vue"));
var _couponList = _interopRequireDefault(require("./couponList.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '券包扫码兑换',
  components: {
    couponCodeList: _couponCodeList.default,
    couponCodeAdd: _couponCodeAdd.default,
    redeemList: _redeemList.default,
    couponList: _couponList.default
  },
  data: function data() {
    return {
      refresh: false,
      actTitle: null,
      actId: null,
      loading: false,
      activeTab: 'couponCodeList',
      tabs: ['couponCodeList', 'redeemList']
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    saved: function saved() {
      this.activeTab = 'couponCodeList';
      this.refresh = true;
    },
    addAct: function addAct() {
      this.activeTab = 'couponCodeAdd';
      this.actId = null; // 新增时清空
    },
    handleCoupon: function handleCoupon(row) {
      this.activeTab = 'couponList';
      // this.actTitle = row.activityName;
      this.actId = row.id;
    },
    handleEdit: function handleEdit(row) {
      this.activeTab = 'couponCodeAdd';
      this.actId = row.id;
    },
    handleCopy: function handleCopy(row) {
      this.activeTab = 'couponCodeAdd';
      this.actId = row.id + '_copy';
    },
    detailUser: function detailUser(row) {
      this.activeTab = 'redeemList';
      // this.actTitle = row.activityName;
      this.actId = row.id;
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
      this.actId = null;
    },
    removeTab: function removeTab(tabName) {
      // const index = this.tabs.indexOf(tabName)
      // if (index !== -1) this.tabs.splice(index, 1)
      // if (this.activeTab === tabName) {
      //     this.activeTab = 'taskList'
      // }
    }
  },
  mounted: function mounted() {}
};